<template>
  <div class="app-vue">
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: "app",
  mounted() {
    this.$store.dispatch('getAppData');
    document.onkeyup = (event) => {
      if (event.key === "Escape") {
        this.$router.push({path: '/'})
      }
    };
  }
}
</script>

<style lang="scss">
@import "../styles/dark";
</style>
